import React from 'react';

import Tags from '../../Tags';
import type { BaseCardProps } from '../types';

const CardTags: React.FC<Pick<BaseCardProps, 'tags'>> = (props) => {
  const { tags } = props;

  if (!tags) {
    return null;
  }

  return (
    <div className="Card__tags__wrapper">
      <div className="Card__tags">
        <Tags items={tags} overflowStartIndex={1} />
      </div>
    </div>
  );
};

export default CardTags;
